import type { BulkLeftCompanyEmployee } from '../../Services';

// ─── Parse error types ────────────────────────────────────────────────────────

export type StructuralError = { kind: 'badHeaders' } | { kind: 'badColumnCount'; count: number };

export type RowError =
  | { kind: 'missingField'; row: number; field: string }
  | { kind: 'invalidUuid'; row: number; value: string }
  | { kind: 'invalidBsn'; row: number; value: string }
  | { kind: 'invalidDate'; row: number; value: string }
  | { kind: 'invalidStartDate'; row: number; value: string };

export type ParseError = StructuralError | RowError;

export type ParseResult = { ok: true; employees: BulkLeftCompanyEmployee[] } | { ok: false; errors: ParseError[] };

// ─── Constants ────────────────────────────────────────────────────────────────

export const NAMED_HEADERS = ['connectionId', 'bsn', 'startDate', 'endDate'] as const;
export const CSV_TEMPLATE_HEADERS = 'connectionId,bsn,startDate,endDate\n';
